export default {
  error_messages: {
    orders_disabled: 'Pedido aquí no disponible actualmente',
  },
};
